import { secondsToDurationLabel } from '../../../../utils/duration';

export const appStackedChartTooltipFormatterFactory = (
  barMetadata: { property: string; label: string }[]
) => (value: string | number | React.ReactText[], name?: unknown) => {
  if (typeof value !== 'number') return value;
  const targetProperty = barMetadata.find((x) => x.property === name);
  return [secondsToDurationLabel(value), targetProperty?.label];
};
